'use client';

import BadgeFactoryClient from '@/app/components/badge/badge-factory.client';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { SocialTagBadge } from '@/app/components/badge/layouts/social-tag/social-tag-badge';
import { TextBadge } from '@/app/components/badge/layouts/text/text-badge';
import { GameLabel, type SocialTagBadgeState } from '@/types/games';
import { getGameInfoBadgeState } from './utils/game-info-helpers';

type GameInfoLabelsProps = {
    className: string;
    label?: string;
    feedsCode?: string;
    isNew?: boolean;
    badgeState?: SocialTagBadgeState;
    uniquePlayerCount?: number;
    showNewBadge?: boolean;
    forceTextBadge?: boolean;
    socialTagClassName?: string;
    testId?: string;
};

export const GameInfoLabels = ({
    className,
    label,
    feedsCode,
    isNew = false,
    badgeState,
    uniquePlayerCount,
    showNewBadge = false,
    forceTextBadge = false,
    socialTagClassName,
    testId
}: GameInfoLabelsProps) => {
    const { hasSocialTag, hasNewBadge, hasBadges } = getGameInfoBadgeState({
        label,
        isNew,
        badgeState,
        uniquePlayerCount,
        includeNewBadge: showNewBadge
    });

    if (!hasBadges) {
        return null;
    }

    const socialTag = hasSocialTag ? (
        <SocialTagBadge state={badgeState} uniquePlayersCount={uniquePlayerCount} />
    ) : null;

    return (
        <div className={className} data-testid={testId}>
            {label ? (
                <BadgeFactoryClient feedsCode={feedsCode} forceTextBadge={forceTextBadge}>
                    <TextBadge label={label} />
                </BadgeFactoryClient>
            ) : null}
            {hasNewBadge ? <TextBadge label={GameLabel.New} /> : null}
            {socialTag && socialTagClassName ? <div className={socialTagClassName}>{socialTag}</div> : socialTag}
        </div>
    );
};
